import styled from 'styled-components';
import { colours } from '../../../../stylings';

export const QuantityButton = styled.button`
  background: none;
  border: 0;
  height: 24px;
  padding: 0;
  position: relative;
  top: 1px;
  width: 24px;

  svg {
    border-radius: 50%;
  }

  &:disabled {
    cursor: not-allowed;

    & svg path {
      fill: ${colours.GREY};
    }
  }

  &:hover,
  &:focus {
    svg {
      background-color: ${colours.LIGHT_BLUE};
    }
  }
`;
